module.exports = __webpack_public_path__ + "static/media/bg-send-love-back-small.b74a26b4.svg";